import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { CurrentUser } from "@/models/auth/current.user";
import { LayoutServiceBus } from "@/services/bus/layout.service";
import { LanguageDto } from "@/server/app.dtos";

@Component
export class BaseSideComponent extends Vue {
  @Prop() args: any;
  @Getter("identity") identity!: CurrentUser;
  @Getter("currentLanguage") currentLanguage!: LanguageDto;

  candEdit(): boolean {
    return false;
  }

  close(): void {
    LayoutServiceBus.closeSideMenu();
  }
}
